import { useState, useEffect } from 'react';

export const usePasswordValidation = ({ password = '', confirmPassword = '' }) => {
  const [validLength, setValidLength] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [upperCase, setUpperCase] = useState(false);
  const [lowerCase, setLowerCase] = useState(false);
  const [match, setMatch] = useState(false);
  const [confirmPassIsFill, setConfirmPassIsFill] = useState(false);

  const isValidPassword = () => {
    return hasNumber && lowerCase && match && upperCase && validLength && confirmPassIsFill;
  };

  useEffect(() => {
    setValidLength(password.length >= 8);
    setUpperCase(password.toLowerCase() !== password);
    setLowerCase(password.toUpperCase() !== password);
    setHasNumber(/\d/.test(password));
    setMatch(!!password && password === confirmPassword);
    setConfirmPassIsFill(confirmPassword !== '');
  }, [password, confirmPassword]);

  return {
    validLength,
    hasNumber,
    upperCase,
    lowerCase,
    match,
    confirmPassIsFill,
    isValidPassword
  };
};
